import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
let initialized = false;
export function App() {
  useEffect(() => {
    if (initialized) return;
    initialized = true;
    document.title = 'Pack Bases del Entrenamiento de Fuerza';
    document.documentElement.setAttribute('lang', 'es');
    document.documentElement.setAttribute('translate', 'no');
    const meta = document.createElement('meta');
    meta.name = 'google';
    meta.content = 'notranslate';
    document.head.appendChild(meta);
    // No Google Fonts - using system fonts for maximum performance
    // System fonts render instantly with zero CLS
    // Defer Meta Pixel — load well after page is interactive
    const loadPixel = () => {
      if ((window as any).fbq) return;
      const pixelId = '804808849254877';
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window,document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${pixelId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 4000
      });
    } else {
      setTimeout(loadPixel, 3000);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}